import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Collapse, Modal, Button, Alert } from "react-bootstrap";

const TrainingCentersAdmin = () => {
  const [collapseBtn, setCollapseBtn] = useState(true);
  const [centers, setCenters] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    program: "",
    seats: "",
    admission: "",
  });

  const [loading, setLoading] = useState(false);

  // ALERT
  const [alert, setAlert] = useState({
    show: false,
    type: "",
    text: "",
  });

  // DELETE MODAL
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // EDIT MODAL
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    name: "",
    program: "",
    seats: "",
    admission: "",
  });

  // ALERT FUNCTION
  const showAlert = (type, text) => {
    setAlert({ show: true, type, text });
    setTimeout(() => {
      setAlert({ show: false, type: "", text: "" });
    }, 3000);
  };

  // FETCH
  const fetchCenters = async () => {
    try {
      const res = await fetch("https://admin.vascularirdoctors.com/backend/training-centers");
      const data = await res.json();
      setCenters(data);
    } catch (err) {
      console.log(err);
      showAlert("danger", "Unable to fetch training centers.");
    }
  };

  useEffect(() => {
    fetchCenters();
  }, []);

  // INPUT CHANGE
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ADD
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("https://admin.vascularirdoctors.com/backend/training-centers", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Training center added successfully.");
        setFormData({
          name: "",
          program: "",
          seats: "",
          admission: "",
        });
        fetchCenters();
      } else {
        showAlert("danger", result.message || "Failed to add.");
      }
    } catch (err) {
      showAlert("danger", "Server error.");
    }

    setLoading(false);
  };

  // DELETE
  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    try {
      const res = await fetch(
        `https://admin.vascularirdoctors.com/backend/training-centers/${deleteId}`,
        { method: "DELETE" }
      );

      if (res.ok) {
        showAlert("success", "Deleted successfully.");
        fetchCenters();
      } else {
        showAlert("danger", "Delete failed.");
      }
    } catch {
      showAlert("danger", "Error deleting.");
    }

    setShowDeleteModal(false);
  };

  // OPEN EDIT
  const openEditModal = (item) => {
    setEditId(item.id);
    setEditData(item);
    setShowModal(true);
  };

  // EDIT CHANGE
  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  // UPDATE
  const updateItem = async () => {
    try {
      const res = await fetch(
        `https://admin.vascularirdoctors.com/backend/training-centers/${editId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(editData),
        }
      );

      if (res.ok) {
        showAlert("success", "Updated successfully.");
        setShowModal(false);
        fetchCenters();
      } else {
        showAlert("danger", "Update failed.");
      }
    } catch {
      showAlert("danger", "Update error.");
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row page-titles align-items-center">
            <div className="col-sm-6">
              <ol className="breadcrumb mt-sm-0 mt-2">
                
                <li className="breadcrumb-item active">
                  Training Centers
                </li>
              </ol>
            </div>

            <div className="col-sm-6 text-sm-end">
              <button
                className="btn btn-outline-danger btn-sm"
                onClick={() => setCollapseBtn(false)}
              >
                <i className="fas fa-times me-1"></i> Close
              </button>
            </div>
          </div>
        </div>

        {/* ALERT */}
        {alert.show && (
          <div className="col-xl-12">
            <Alert variant={alert.type}>{alert.text}</Alert>
          </div>
        )}

        {/* FORM */}
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className="content-title d-flex justify-content-between">
              <div className="cpa">Add Training Center</div>
              <button
                className="btn btn-sm btn-light border"
                onClick={() => setCollapseBtn(!collapseBtn)}
              >
                <i
                  className={`fas ${
                    collapseBtn ? "fa-angle-up" : "fa-angle-down"
                  }`}
                />
              </button>
            </div>

            <Collapse in={collapseBtn}>
              <div className="card-body">
                <form onSubmit={submitHandler}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label>Institute Name</label>
                      <input
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Program</label>
                      <input
                        className="form-control"
                        name="program"
                        value={formData.program}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Seats</label>
                      <input
                        className="form-control"
                        name="seats"
                        value={formData.seats}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Admission</label>
                      <input
                        className="form-control"
                        name="admission"
                        value={formData.admission}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-xl-12 text-end">
                      <button className="btn btn-primary">
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </Collapse>
          </div>
        </div>

        {/* LIST */}
        <div className="col-xl-12 mt-4">
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">Training Centers List</div>
            </div>

            <div className="card-body">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Program</th>
                    <th>Seats</th>
                    <th>Admission</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {centers.map((item, i) => (
                    <tr key={item.id}>
                      <td>{i + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.program}</td>
                      <td>{item.seats}</td>
                      <td>{item.admission}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-info me-2"
                          onClick={() => openEditModal(item)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => confirmDelete(item.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Center</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {Object.keys(editData).map(
            (key) =>
              key !== "id" && (
                <div className="mb-3" key={key}>
                  <label>{key}</label>
                  <input
                    className="form-control"
                    name={key}
                    value={editData[key]}
                    onChange={handleEditChange}
                  />
                </div>
              )
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => setShowModal(false)}>Cancel</Button>
          <Button onClick={updateItem}>Update</Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE MODAL */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure?</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={deleteItem}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TrainingCentersAdmin;